const RANK_VALUE = { A: 8, B: 7, C: 6, D: 5, E: 4, F: 3, G: 2, H: 1 };

const normalizeRank = (rank) => String(rank || '').trim().toUpperCase();

const singleHandicap = (diff) => {
  if (diff <= 0) return null;
  return String(diff + 1).repeat(3);
};

const doubleHandicap = (diff) => {
  if (diff <= 0) return null;
  const base = Math.floor(diff / 2) + 1;
  if (diff % 2 === 0) return String(base).repeat(3);
  return diff === 1 ? '202' : `${base}${base + 1}${base}`;
};

export const getMatchHandicap = (homeRanks, guestRanks) => {
  const homeValues = homeRanks.map((rank) => RANK_VALUE[normalizeRank(rank)]).filter(Boolean);
  const guestValues = guestRanks.map((rank) => RANK_VALUE[normalizeRank(rank)]).filter(Boolean);

  if (homeValues.length === 0 || guestValues.length === 0) return null;

  const homeTotal = homeValues.reduce((sum, value) => sum + value, 0);
  const guestTotal = guestValues.reduce((sum, value) => sum + value, 0);
  const diff = Math.abs(homeTotal - guestTotal);
  const isDouble = homeValues.length > 1 || guestValues.length > 1;
  const value = isDouble ? doubleHandicap(diff) : singleHandicap(diff);

  if (!value) return null;
  return { side: homeTotal < guestTotal ? 'home' : 'guest', value };
};
